// extracted by mini-css-extract-plugin
export default {"resultItem":"DownloadItems_resultItem__kNfw4","button":"DownloadItems_button__LX79S"};